module.exports = __webpack_public_path__ + "static/img/6.00e235a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chongqing/6.jpg
// module id = B5rE
// module chunks = 1